/**
 * When to reconnect to matching-server after a connection closes or fails.
 *
 * `failures` counts attempts in a row that never got a message. A connection
 * only counts as working once its first message (the session snapshot)
 * arrives: matching-server accepts every WebSocket and then closes a bad one
 * with 4001, so "open" alone proves nothing.
 */

/** Give up after this many failed attempts in a row. */
export const MAX_RETRIES = 5;

/** matching-server's close code for a token it doesn't accept. */
export const INVALID_TOKEN_CLOSE_CODE = 4001;

export type RetryDecision = { retry: true; delayMs: number } | { retry: false };

/**
 * @param failures failed attempts in a row, including the one that just ended
 * @param closeCode the WebSocket close code, if the attempt got that far
 */
export function nextRetry(failures: number, closeCode?: number): RetryDecision {
  // The token was refused. Each retry would mint another token for the same
  // session and be refused the same way, so stop instead of looping.
  if (closeCode === INVALID_TOKEN_CLOSE_CODE) return { retry: false };
  if (failures > MAX_RETRIES) return { retry: false };
  return { retry: true, delayMs: Math.min(1000 * 2 ** (failures - 1), 8000) };
}
